module.exports = __webpack_public_path__ + "img/knight4_02.1316a329.jpg";